import React from 'react';

import { connectProps } from 'store';

import IconButton from '@material-ui/core/IconButton';
//import NavigateBefore from '@material-ui/icons/NavigateBefore';
//import NavigateNext from '@material-ui/icons/NavigateNext';
import TextField from '@material-ui/core/TextField';
//import Button from '@material-ui/core/Button';

import leftArrow from '../../icons/left-arrow.png';
import rightArrow from '../../icons/right-arrow.png';

import {
  updateCurrentPage,
  currentPage,
} from 'model/component-props';

class Paging extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      typedPage: this.props.currentPage + 1,
    }
  };

  componentDidUpdate(prevProps) {
    prevProps.currentPage !== this.props.currentPage && this.setState({typedPage: this.props.currentPage + 1});
  }

  handlePrevious = () => {
    window.scrollTo(0, 0);
    this.props.currentPage === 0 ? {} : this.props.updateCurrentPage(this.props.currentPage - 1);
  }


  handleNext = () => {
    window.scrollTo(0, 0);
    this.props.currentPage === this.props.numberOfPages - 1 ? {} : this.props.updateCurrentPage(this.props.currentPage + 1);
  }

  handleClick = () => {
    this.state.typedPage > 0 && this.state.typedPage < this.props.numberOfPages && this.props.updateCurrentPage(parseInt(this.state.typedPage - 1, 10));
    this.state.typedPage <= 0 && this.props.updateCurrentPage(0);
    this.state.typedPage >= this.props.numberOfPages && this.props.updateCurrentPage(this.props.numberOfPages - 1);
  }

  handleFieldValue = event => this.setState({typedPage: event.target.value});

  render() {
    const { numberOfPages } = this.props;
    const { typedPage } = this.state;
    return (
      <div>
        <div style={{display: 'block'}}>
          <table>
            <tbody>
              <tr>
                <td>
                  <IconButton onClick={() => this.handlePrevious()}>
                    <img src={leftArrow} alt="previous" style={{width: 25}} />
                  </IconButton></td>
                <td><span style={{paddingRight: '10px'}}>page</span></td>
                <td><TextField
                  id={'current-page'}
                  value={typedPage}
                  onChange={this.handleFieldValue}
                  style={{width: '35px'}}
                />
                </td>
                <td><span style={{paddingLeft: '10px'}}>of {numberOfPages}</span></td>
                <td>
                  <button style={{backgroundColor: '#123C69', color: 'white', borderRadius: 10, margin: 10, padding: '15px'}} onClick={() => this.handleClick()}>
                  {'GO'}
                  </button>
                </td>
                <td>
                  <IconButton onClick={() => this.handleNext()}>
                    <img src={rightArrow} alt="previous" style={{width: 25}} />
                  </IconButton></td>
              </tr>
            </tbody>
          </table>  
        </div>
      </div>
    )
  }
}

export default connectProps(updateCurrentPage, currentPage)(Paging);



// WEBPACK FOOTER //
// ./src/components/paging/paging.js